const levels = {
  admin: 3,
  writer: 2,
  reader: 1,
  none: 0,
};

export default levels;
